import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import 'themes/styles/app.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'mobx-react';
import { I18nextProvider } from 'react-i18next';
import { RouterContext } from 'mobx-state-router';
import { localizationService } from 'core/services';
import { App, Loader } from 'core/components';
import { bootstrap } from 'common/infrastructure';
import { RootStore } from 'common/stores';
import { StoreContext } from 'core/stores/StoreContext';
import Modal from 'react-modal';

function startApplication() {
	const configuration = bootstrap.run();

	const rootStore = new RootStore(configuration);
	renderApp({ rootStore });
}

function renderApp({ rootStore }) {
	Modal.setAppElement('#root')
	const logReactError = (kind, reReport) => (error, errorInfo) => {
		// React 19 swallows the real error/stack behind the dev overlay (minified)
		// and logs nothing actionable to the console. Surface the full error object,
		// its stack, and the React component stack so failures are diagnosable.
		console.error(
			`[React ${kind} error]`,
			error,
			'\nmessage:', error && error.message,
			'\nstack:', error && error.stack,
			'\ncomponentStack:', errorInfo && errorInfo.componentStack
		);
		// Overriding onUncaughtError replaces React's default reportError() call,
		// which is what fires the window 'error' event the dev overlay listens for.
		// Re-report so the overlay still shows alongside our log.
		if (reReport && typeof reportError === 'function') {
			reportError(error);
		}
	};
	const root = createRoot(document.getElementById('root'), {
		onCaughtError: logReactError('caught', false),
		onUncaughtError: logReactError('uncaught', true),
		onRecoverableError: logReactError('recoverable', false),
	});
	root.render(
		<I18nextProvider i18n={localizationService}>
			<StoreContext.Provider value={rootStore}>
				{/* mobx-react <Provider> kept alongside StoreContext during the inject ->
				    useStores() migration; both resolve to the same rootStore. */}
				<Provider rootStore={rootStore}>
					{/* mobx-state-router v6: RouterLink/RouterView pull the store from a React
					    context (useRouterStore hook). Provide the inner v6 store here. */}
					<RouterContext.Provider value={rootStore.routerStore.router}>
						{/* Gate render until translations load. react-i18next dropped the old
						    `react.wait`; with useSuspense:true, consumers suspend until the
						    /locales namespace fetch resolves, instead of flashing raw i18n keys
						    on first (cold-cache) load. The fallback is <Loader/>, not null —
						    App's own loader lives inside this boundary, so a null fallback
						    unmounts it and leaves a blank page for the whole fetch. Loader uses
						    no translations, so it cannot re-suspend. */}
						<React.Suspense fallback={<Loader/>}>
							<App />
						</React.Suspense>
					</RouterContext.Provider>
				</Provider>
			</StoreContext.Provider>
		</I18nextProvider>
	);
}

startApplication();